import React from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Price from "@/pages/Main/ManagePrice/table/tableRow/Price";

import { selectLocalization } from "@/store/store/selectors";

import { Colors } from "@/theme";
import useStyles from "./styles";
import { getLocalisationVal } from "@/utils/localizationUtil";

const OtherStoreProducts = ({ otherStoresProducts }) => {
  const classes = useStyles();
  const localization = useSelector(selectLocalization);

  const getRecentChangeOfGroup = (group) => {
    return group
      .map((product) => product.prices?.[0]?.last_updated)
      ?.filter((time) => !!time)
      ?.sort((a, b) => moment(b) > moment(a))?.[0];
  };

  return (
    <Box mb={10}>
      {otherStoresProducts?.map((group, id) => (
        <Box
          key={`group-${id}`}
          borderBottom={`1px solid ${Colors.GRAY_BORDER}`}
          padding={4}
          paddingTop={id === 0 ? 0 : 4}
        >
          <Box display={"flex"} alignItems={"center"} flexWrap={"wrap"}>
            <Box>
              <img
                src={group[0]?.store?.brand?.logo?.thumbnail}
                width={70}
                height={70}
              />
            </Box>
            <Box width={150} ml={10}>
              <span className={classes.addressText}>
                {group[0]?.store?.name}
              </span>
            </Box>
            <Box width={100} ml={5}>
              <span className={classes.addressText}>
                {getLocalisationVal(localization, group[0].distance)} miles
              </span>
            </Box>
            <Box ml={10}>
              <span className={classes.addressText}>
                {!!getRecentChangeOfGroup(group) &&
                  moment
                    .utc(getRecentChangeOfGroup(group))
                    .local()
                    .format("DD MMM HH:mm")}
              </span>
            </Box>
          </Box>
          <Box display={"flex"} flexWrap={"wrap"} mt={3}>
            {group
              ?.sort((a, b) => a.product_code.localeCompare(b.product_code))
              ?.map((product, pid, array) => (
                <Box key={`${id}-${pid}`} mb={3} mr={2}>
                  <Price
                    mr={0}
                    isLast={pid === array.length - 1}
                    key={`${id}-${pid}`}
                    localization={localization}
                    code={product.product_code}
                    price={parseFloat(product?.prices?.[0]?.gross_price)}
                    trend={product.prices?.[0]?.history?.trend}
                  />
                  <span className={classes.dateText}>
                    {moment
                      .utc(product?.prices?.[0]?.last_updated)
                      .local()
                      .format("HH:mm DD/MM/YY")}
                  </span>
                </Box>
              ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default OtherStoreProducts;
